export {
  ping
};

/**
 * It seems that the only one way to ping an interactive deployment
 * is it create frame and await for first message.
 * @param url
 * @return {Promise<Response>|Promise<unknown>|Promise<void>}
 */
function ping (url) {
  const frame = document.createElement('iframe');
  const race = new Promise((resolve, reject) => {
    const timeout = setTimeout(() => {
      window.removeEventListener('message', onMessage);
      frame.remove();
      reject('timeout');
    }, 3_000);
    const onMessage = ev => {
      if (ev.source !== frame.contentWindow) {
        return;
      }
      if (ev.data.type === 'app:loaded') {
        window.removeEventListener('message', onMessage);
        frame.remove();
        clearTimeout(timeout);
        resolve('loaded');
      }
    };

    window.addEventListener('message', onMessage);
  });

  document.body.appendChild(frame);
  frame.src = url;
  frame.style.display = 'none';

  return race;
}
